/**
 * 国の列挙クラス
 * @param code : 国コード
 * @param name : 国名(漢字)
 * @param name_en : 国名(英語)
 */
const _countries = [
  { "code": 'JPN', "name": '日本', "name_en": 'Japan' },
  { "code": 'CHN', "name": '中華人民共和国', "name_en": 'China' },
  { "code": 'KOR', "name": '大韓民国', "name_en": 'Korea, Republic of' },
  { "code": 'VNM', "name": 'ベトナム', "name_en": 'Viet Nam' },
  { "code": 'PHL', "name": 'フィリピン', "name_en": 'Philippines' },
  { "code": 'BRA', "name": 'ブラジル', "name_en": 'Brazil' },
  { "code": 'NPL', "name": 'ネパール', "name_en": 'Nepal' },
  { "code": 'TWN', "name": '中国台湾省（中華民国）', "name_en": 'Taiwan, Province of China' },
  { "code": 'USA', "name": 'アメリカ合衆国', "name_en": 'United States' },
  { "code": 'IDN', "name": 'インドネシア', "name_en": 'Indonesia' },
  { "code": 'THA', "name": 'タイ', "name_en": 'Thailand' },
  { "code": 'PER', "name": 'ペルー', "name_en": 'Peru' },
  { "code": 'IND', "name": 'インド', "name_en": 'India' },
  { "code": 'PRK', "name": '朝鮮民主主義人民共和国', "name_en": 'Korea, Democratic People\'s Republic of' },
  { "code": 'MMR', "name": 'ミャンマー', "name_en": 'Myanmar' },
  { "code": 'LKA', "name": 'スリランカ', "name_en": 'Sri Lanka' },
  { "code": 'GBR', "name": 'イギリス', "name_en": 'United Kingdom' },
  { "code": 'PAK', "name": 'パキスタン', "name_en": 'Pakistan' },
  { "code": 'BGD', "name": 'バングラデシュ', "name_en": 'Bangladesh' },
  { "code": 'FRA', "name": 'フランス', "name_en": 'France' },
  { "code": 'KHM', "name": 'カンボジア', "name_en": 'Cambodia' },
  { "code": 'AUS', "name": 'オーストラリア', "name_en": 'Australia' },
  { "code": 'MNG', "name": 'モンゴル', "name_en": 'Mongolia' },
  { "code": 'CAN', "name": 'カナダ', "name_en": 'Canada' },
  { "code": 'MYS', "name": 'マレーシア', "name_en": 'Malaysia' },
  { "code": 'RUS', "name": 'ロシア連邦', "name_en": 'Russian Federation' },
  { "code": 'DEU', "name": 'ドイツ', "name_en": 'Germany' },
  { "code": 'BOL', "name": 'ボリビア多民族国', "name_en": 'Bolivia, Plurinational State of' },
  { "code": 'TUR', "name": 'トルコ', "name_en": 'Turkey' },
  { "code": 'ITA', "name": 'イタリア', "name_en": 'Italy' },
  { "code": 'IRN', "name": 'イラン・イスラム共和国', "name_en": 'Iran, Islamic Republic of' },
  { "code": 'UZB', "name": 'ウズベキスタン', "name_en": 'Uzbekistan' },
  { "code": 'NZL', "name": 'ニュージーランド', "name_en": 'New Zealand' },
  { "code": 'ESP', "name": 'スペイン', "name_en": 'Spain' },
  { "code": 'AFG', "name": 'アフガニスタン', "name_en": 'Afghanistan' },
  { "code": 'SGP', "name": 'シンガポール', "name_en": 'Singapore' },
  { "code": 'NGA', "name": 'ナイジェリア', "name_en": 'Nigeria' },
  { "code": 'ARG', "name": 'アルゼンチン', "name_en": 'Argentina' },
  { "code": 'LAO', "name": 'ラオス人民民主共和国', "name_en": 'Lao People\'s Democratic Republic' },
  { "code": 'MEX', "name": 'メキシコ', "name_en": 'Mexico' },
  { "code": 'COL', "name": 'コロンビア', "name_en": 'Colombia' },
  { "code": 'GHA', "name": 'ガーナ', "name_en": 'Ghana' },
  { "code": 'ROU', "name": 'ルーマニア', "name_en": 'Romania' },
  { "code": 'PRY', "name": 'パラグアイ', "name_en": 'Paraguay' },
  { "code": 'EGY', "name": 'エジプト', "name_en": 'Egypt' },
  { "code": 'UKR', "name": 'ウクライナ', "name_en": 'Ukraine' },
  { "code": 'SWE', "name": 'スウェーデン', "name_en": 'Sweden' },
  { "code": 'POL', "name": 'ポーランド', "name_en": 'Poland' },
  { "code": 'NLD', "name": 'オランダ', "name_en": 'Netherlands' },
  { "code": 'IRL', "name": 'アイルランド', "name_en": 'Ireland' },
  { "code": 'CHE', "name": 'スイス', "name_en": 'Switzerland' },
  { "code": 'ALA', "name": 'オーランド諸島', "name_en": 'Åland Islands' },
  { "code": 'ALB', "name": 'アルバニア', "name_en": 'Albania' },
  { "code": 'DZA', "name": 'アルジェリア', "name_en": 'Algeria' },
  { "code": 'ASM', "name": 'アメリカ領サモア', "name_en": 'American Samoa' },
  { "code": 'AND', "name": 'アンドラ', "name_en": 'Andorra' },
  { "code": 'AGO', "name": 'アンゴラ', "name_en": 'Angola' },
  { "code": 'AIA', "name": 'アンギラ', "name_en": 'Anguilla' },
  { "code": 'ATA', "name": '南極', "name_en": 'Antarctica' },
  { "code": 'ATG', "name": 'アンティグア・バーブーダ', "name_en": 'Antigua and Barbuda' },
  { "code": 'ARM', "name": 'アルメニア', "name_en": 'Armenia' },
  { "code": 'ABW', "name": 'アルバ', "name_en": 'Aruba' },
  { "code": 'AUT', "name": 'オーストリア', "name_en": 'Austria' },
  { "code": 'AZE', "name": 'アゼルバイジャン', "name_en": 'Azerbaijan' },
  { "code": 'BHS', "name": 'バハマ', "name_en": 'Bahamas' },
  { "code": 'BHR', "name": 'バーレーン', "name_en": 'Bahrain' },
  { "code": 'BRB', "name": 'バルバドス', "name_en": 'Barbados' },
  { "code": 'BLR', "name": 'ベラルーシ', "name_en": 'Belarus' },
  { "code": 'BEL', "name": 'ベルギー', "name_en": 'Belgium' },
  { "code": 'BLZ', "name": 'ベリーズ', "name_en": 'Belize' },
  { "code": 'BEN', "name": 'ベナン', "name_en": 'Benin' },
  { "code": 'BMU', "name": 'バミューダ', "name_en": 'Bermuda' },
  { "code": 'BTN', "name": 'ブータン', "name_en": 'Bhutan' },
  { "code": 'BES', "name": 'ボネール、シント・ユースタティウスおよびサバ', "name_en": 'Bonaire, Saint Eustatius and Saba' },
  { "code": 'BIH', "name": 'ボスニア・ヘルツェゴビナ', "name_en": 'Bosnia and Herzegovina' },
  { "code": 'BWA', "name": 'ボツワナ', "name_en": 'Botswana' },
  { "code": 'BVT', "name": 'ブーベ島', "name_en": 'Bouvet Island' },
  { "code": 'IOT', "name": 'イギリス領インド洋地域', "name_en": 'British Indian Ocean Territory' },
  { "code": 'BRN', "name": 'ブルネイ・ダルサラーム', "name_en": 'Brunei Darussalam' },
  { "code": 'BGR', "name": 'ブルガリア', "name_en": 'Bulgaria' },
  { "code": 'BFA', "name": 'ブルキナファソ', "name_en": 'Burkina Faso' },
  { "code": 'BDI', "name": 'ブルンジ', "name_en": 'Burundi' },
  { "code": 'CMR', "name": 'カメルーン', "name_en": 'Cameroon' },
  { "code": 'CPV', "name": 'カーボベルデ', "name_en": 'Cape Verde' },
  { "code": 'CYM', "name": 'ケイマン諸島', "name_en": 'Cayman Islands' },
  { "code": 'CAF', "name": '中央アフリカ共和国', "name_en": 'Central African Republic' },
  { "code": 'TCD', "name": 'チャド', "name_en": 'Chad' },
  { "code": 'CHL', "name": 'チリ', "name_en": 'Chile' },
  { "code": 'CXR', "name": 'クリスマス島', "name_en": 'Christmas Island' },
  { "code": 'CCK', "name": 'ココス（キーリング）諸島', "name_en": 'Cocos (Keeling) Islands' },
  { "code": 'COM', "name": 'コモロ', "name_en": 'Comoros' },
  { "code": 'COG', "name": 'コンゴ共和国', "name_en": 'Congo' },
  { "code": 'COD', "name": 'コンゴ民主共和国', "name_en": 'Congo, the Democratic Republic of the' },
  { "code": 'COK', "name": 'クック諸島', "name_en": 'Cook Islands' },
  { "code": 'CRI', "name": 'コスタリカ', "name_en": 'Costa Rica' },
  { "code": 'CIV', "name": 'コートジボワール', "name_en": 'Côte d\'Ivoire' },
  { "code": 'HRV', "name": 'クロアチア', "name_en": 'Croatia' },
  { "code": 'CUB', "name": 'キューバ', "name_en": 'Cuba' },
  { "code": 'CUW', "name": 'キュラソー', "name_en": 'Curaçao' },
  { "code": 'CYP', "name": 'キプロス', "name_en": 'Cyprus' },
  { "code": 'CZE', "name": 'チェコ', "name_en": 'Czechia' },
  { "code": 'DNK', "name": 'デンマーク', "name_en": 'Denmark' },
  { "code": 'DJI', "name": 'ジブチ', "name_en": 'Djibouti' },
  { "code": 'DMA', "name": 'ドミニカ国', "name_en": 'Dominica' },
  { "code": 'DOM', "name": 'ドミニカ共和国', "name_en": 'Dominican Republic' },
  { "code": 'ECU', "name": 'エクアドル', "name_en": 'Ecuador' },
  { "code": 'SLV', "name": 'エルサルバドル', "name_en": 'El Salvador' },
  { "code": 'GNQ', "name": '赤道ギニア', "name_en": 'Equatorial Guinea' },
  { "code": 'ERI', "name": 'エリトリア', "name_en": 'Eritrea' },
  { "code": 'EST', "name": 'エストニア', "name_en": 'Estonia' },
  { "code": 'SWZ', "name": 'エスワティニ', "name_en": 'Eswatini' },
  { "code": 'ETH', "name": 'エチオピア', "name_en": 'Ethiopia' },
  { "code": 'FLK', "name": 'フォークランド（マルビナス）諸島', "name_en": 'Falkland Islands (Malvinas)' },
  { "code": 'FRO', "name": 'フェロー諸島', "name_en": 'Faroe Islands' },
  { "code": 'FJI', "name": 'フィジー', "name_en": 'Fiji' },
  { "code": 'FIN', "name": 'フィンランド', "name_en": 'Finland' },
  { "code": 'GUF', "name": 'フランス領ギアナ', "name_en": 'French Guiana' },
  { "code": 'PYF', "name": 'フランス領ポリネシア', "name_en": 'French Polynesia' },
  { "code": 'ATF', "name": 'Flag of the French Southern and Antarctic Lands.svg フランス領南方・南極地域', "name_en": 'French Southern Territories' },
  { "code": 'GAB', "name": 'ガボン', "name_en": 'Gabon' },
  { "code": 'GMB', "name": 'ガンビア', "name_en": 'Gambia' },
  { "code": 'GEO', "name": 'ジョージア', "name_en": 'Georgia' },
  { "code": 'GIB', "name": 'ジブラルタル', "name_en": 'Gibraltar' },
  { "code": 'GRC', "name": 'ギリシャ', "name_en": 'Greece' },
  { "code": 'GRL', "name": 'グリーンランド', "name_en": 'Greenland' },
  { "code": 'GRD', "name": 'グレナダ', "name_en": 'Grenada' },
  { "code": 'GLP', "name": 'グアドループ', "name_en": 'Guadeloupe' },
  { "code": 'GUM', "name": 'グアム', "name_en": 'Guam' },
  { "code": 'GTM', "name": 'グアテマラ', "name_en": 'Guatemala' },
  { "code": 'GGY', "name": 'ガーンジー', "name_en": 'Guernsey' },
  { "code": 'GIN', "name": 'ギニア', "name_en": 'Guinea' },
  { "code": 'GNB', "name": 'ギニアビサウ', "name_en": 'Guinea-Bissau' },
  { "code": 'GUY', "name": 'ガイアナ', "name_en": 'Guyana' },
  { "code": 'HTI', "name": 'ハイチ', "name_en": 'Haiti' },
  { "code": 'HMD', "name": 'ハード島とマクドナルド諸島', "name_en": 'Heard Island and McDonald Islands' },
  { "code": 'VAT', "name": 'バチカン市国', "name_en": 'Holy See (Vatican City State)' },
  { "code": 'HND', "name": 'ホンジュラス', "name_en": 'Honduras' },
  { "code": 'HKG', "name": '香港', "name_en": 'Hong Kong' },
  { "code": 'HUN', "name": 'ハンガリー', "name_en": 'Hungary' },
  { "code": 'ISL', "name": 'アイスランド', "name_en": 'Iceland' },
  { "code": 'IRQ', "name": 'イラク', "name_en": 'Iraq' },
  { "code": 'IMN', "name": 'マン島', "name_en": 'Isle of Man' },
  { "code": 'ISR', "name": 'イスラエル', "name_en": 'Israel' },
  { "code": 'JAM', "name": 'ジャマイカ', "name_en": 'Jamaica' },
  { "code": 'JEY', "name": 'ジャージー', "name_en": 'Jersey' },
  { "code": 'JOR', "name": 'ヨルダン', "name_en": 'Jordan' },
  { "code": 'KAZ', "name": 'カザフスタン', "name_en": 'Kazakhstan' },
  { "code": 'KEN', "name": 'ケニア', "name_en": 'Kenya' },
  { "code": 'KIR', "name": 'キリバス', "name_en": 'Kiribati' },
  { "code": 'KWT', "name": 'クウェート', "name_en": 'Kuwait' },
  { "code": 'KGZ', "name": 'キルギス', "name_en": 'Kyrgyzstan' },
  { "code": 'LVA', "name": 'ラトビア', "name_en": 'Latvia' },
  { "code": 'LBN', "name": 'レバノン', "name_en": 'Lebanon' },
  { "code": 'LSO', "name": 'レソト', "name_en": 'Lesotho' },
  { "code": 'LBR', "name": 'リベリア', "name_en": 'Liberia' },
  { "code": 'LBY', "name": 'リビア', "name_en": 'Libya' },
  { "code": 'LIE', "name": 'リヒテンシュタイン', "name_en": 'Liechtenstein' },
  { "code": 'LTU', "name": 'リトアニア', "name_en": 'Lithuania' },
  { "code": 'LUX', "name": 'ルクセンブルク', "name_en": 'Luxembourg' },
  { "code": 'MAC', "name": 'マカオ', "name_en": 'Macau' },
  { "code": 'MDG', "name": 'マダガスカル', "name_en": 'Madagascar' },
  { "code": 'MWI', "name": 'マラウイ', "name_en": 'Malawi' },
  { "code": 'MDV', "name": 'モルディブ', "name_en": 'Maldives' },
  { "code": 'MLI', "name": 'マリ', "name_en": 'Mali' },
  { "code": 'MLT', "name": 'マルタ', "name_en": 'Malta' },
  { "code": 'MHL', "name": 'マーシャル諸島', "name_en": 'Marshall Islands' },
  { "code": 'MTQ', "name": 'マルティニーク', "name_en": 'Martinique' },
  { "code": 'MRT', "name": 'モーリタニア', "name_en": 'Mauritania' },
  { "code": 'MUS', "name": 'モーリシャス', "name_en": 'Mauritius' },
  { "code": 'MYT', "name": 'マヨット', "name_en": 'Mayotte' },
  { "code": 'FSM', "name": 'ミクロネシア連邦', "name_en": 'Micronesia, Federated States of' },
  { "code": 'MDA', "name": 'モルドバ共和国', "name_en": 'Moldova, Republic of' },
  { "code": 'MCO', "name": 'モナコ', "name_en": 'Monaco' },
  { "code": 'MNE', "name": 'モンテネグロ', "name_en": 'Montenegro' },
  { "code": 'MSR', "name": 'モントセラト', "name_en": 'Montserrat' },
  { "code": 'MAR', "name": 'モロッコ', "name_en": 'Morocco' },
  { "code": 'MOZ', "name": 'モザンビーク', "name_en": 'Mozambique' },
  { "code": 'NAM', "name": 'ナミビア', "name_en": 'Namibia' },
  { "code": 'NRU', "name": 'ナウル', "name_en": 'Nauru' },
  { "code": 'NCL', "name": 'ニューカレドニア', "name_en": 'New Caledonia' },
  { "code": 'NIC', "name": 'ニカラグア', "name_en": 'Nicaragua' },
  { "code": 'NER', "name": 'ニジェール', "name_en": 'Niger' },
  { "code": 'NIU', "name": 'ニウエ', "name_en": 'Niue' },
  { "code": 'NFK', "name": 'ノーフォーク島', "name_en": 'Norfolk Island' },
  { "code": 'MKD', "name": '北マケドニア', "name_en": 'North Macedonia' },
  { "code": 'MNP', "name": '北マリアナ諸島', "name_en": 'Northern Mariana Islands' },
  { "code": 'NOR', "name": 'ノルウェー', "name_en": 'Norway' },
  { "code": 'OMN', "name": 'オマーン', "name_en": 'Oman' },
  { "code": 'PLW', "name": 'パラオ', "name_en": 'Palau' },
  { "code": 'PSE', "name": 'パレスチナ', "name_en": 'Palestinian Territory, Occupied' },
  { "code": 'PAN', "name": 'パナマ', "name_en": 'Panama' },
  { "code": 'PNG', "name": 'パプアニューギニア', "name_en": 'Papua New Guinea' },
  { "code": 'PCN', "name": 'ピトケアン', "name_en": 'Pitcairn' },
  { "code": 'PRT', "name": 'ポルトガル', "name_en": 'Portugal' },
  { "code": 'PRI', "name": 'プエルトリコ', "name_en": 'Puerto Rico' },
  { "code": 'QAT', "name": 'カタール', "name_en": 'Qatar' },
  { "code": 'REU', "name": 'レユニオン', "name_en": 'Réunion' },
  { "code": 'RWA', "name": 'ルワンダ', "name_en": 'Rwanda' },
  { "code": 'BLM', "name": 'サン・バルテルミー', "name_en": 'Saint Barthélemy' },
  { "code": 'SHN', "name": 'セントヘレナ・アセンションおよびトリスタンダクーニャ', "name_en": 'Saint Helena, Ascension and Tristan da Cunha' },
  { "code": 'KNA', "name": 'セントクリストファー・ネイビス', "name_en": 'Saint Kitts and Nevis' },
  { "code": 'LCA', "name": 'セントルシア', "name_en": 'Saint Lucia' },
  { "code": 'MAF', "name": 'サン・マルタン（フランス領）', "name_en": 'Saint Martin (French part)' },
  { "code": 'SPM', "name": 'サンピエール島・ミクロン島', "name_en": 'Saint Pierre and Miquelon' },
  { "code": 'VCT', "name": 'セントビンセントおよびグレナディーン諸島', "name_en": 'Saint Vincent and the Grenadines' },
  { "code": 'WSM', "name": 'サモア', "name_en": 'Samoa' },
  { "code": 'SMR', "name": 'サンマリノ', "name_en": 'San Marino' },
  { "code": 'STP', "name": 'サントメ・プリンシペ', "name_en": 'Sao Tome and Principe' },
  { "code": 'SAU', "name": 'サウジアラビア', "name_en": 'Saudi Arabia' },
  { "code": 'SEN', "name": 'セネガル', "name_en": 'Senegal' },
  { "code": 'SRB', "name": 'セルビア', "name_en": 'Serbia' },
  { "code": 'SYC', "name": 'セーシェル', "name_en": 'Seychelles' },
  { "code": 'SLE', "name": 'シエラレオネ', "name_en": 'Sierra Leone' },
  { "code": 'SXM', "name": 'シント・マールテン（オランダ領）', "name_en": 'Sint Maarten (Dutch part)' },
  { "code": 'SVK', "name": 'スロバキア', "name_en": 'Slovakia' },
  { "code": 'SVN', "name": 'スロベニア', "name_en": 'Slovenia' },
  { "code": 'SLB', "name": 'ソロモン諸島', "name_en": 'Solomon Islands' },
  { "code": 'SOM', "name": 'ソマリア', "name_en": 'Somalia' },
  { "code": 'ZAF', "name": '南アフリカ', "name_en": 'South Africa' },
  { "code": 'SGS', "name": 'サウスジョージア・サウスサンドウィッチ諸島', "name_en": 'South Georgia and the South Sandwich Islands' },
  { "code": 'SSD', "name": '南スーダン', "name_en": 'South Sudan' },
  { "code": 'SDN', "name": 'スーダン', "name_en": 'Sudan' },
  { "code": 'SUR', "name": 'スリナム', "name_en": 'Suriname' },
  { "code": 'SJM', "name": 'スヴァールバル諸島およびヤンマイエン島', "name_en": 'Svalbard and Jan Mayen' },
  { "code": 'SYR', "name": 'シリア・アラブ共和国', "name_en": 'Syrian Arab Republic' },
  { "code": 'TJK', "name": 'タジキスタン', "name_en": 'Tajikistan' },
  { "code": 'TZA', "name": 'タンザニア', "name_en": 'Tanzania, United Republic of' },
  { "code": 'TLS', "name": '東ティモール', "name_en": 'Timor-Leste' },
  { "code": 'TGO', "name": 'トーゴ', "name_en": 'Togo' },
  { "code": 'TKL', "name": 'トケラウ', "name_en": 'Tokelau' },
  { "code": 'TON', "name": 'トンガ', "name_en": 'Tonga' },
  { "code": 'TTO', "name": 'トリニダード・トバゴ', "name_en": 'Trinidad and Tobago' },
  { "code": 'TUN', "name": 'チュニジア', "name_en": 'Tunisia' },
  { "code": 'TKM', "name": 'トルクメニスタン', "name_en": 'Turkmenistan' },
  { "code": 'TCA', "name": 'タークス・カイコス諸島', "name_en": 'Turks and Caicos Islands' },
  { "code": 'TUV', "name": 'ツバル', "name_en": 'Tuvalu' },
  { "code": 'UGA', "name": 'ウガンダ', "name_en": 'Uganda' },
  { "code": 'ARE', "name": 'アラブ首長国連邦', "name_en": 'United Arab Emirates' },
  { "code": 'UMI', "name": '合衆国領有小離島', "name_en": 'United States Minor Outlying Islands' },
  { "code": 'URY', "name": 'ウルグアイ', "name_en": 'Uruguay' },
  { "code": 'VUT', "name": 'バヌアツ', "name_en": 'Vanuatu' },
  { "code": 'VEN', "name": 'ベネズエラ・ボリバル共和国', "name_en": 'Venezuela, Bolivarian Republic of' },
  { "code": 'VGB', "name": 'イギリス領ヴァージン諸島', "name_en": 'Virgin Islands, British' },
  { "code": 'VIR', "name": 'アメリカ領ヴァージン諸島', "name_en": 'Virgin Islands, U.S.' },
  { "code": 'WLF', "name": 'ウォリス・フツナ', "name_en": 'Wallis and Futuna' },
  { "code": 'ESH', "name": '西サハラ', "name_en": 'Western Sahara' },
  { "code": 'YEM', "name": 'イエメン', "name_en": 'Yemen' },
  { "code": 'ZMB', "name": 'ザンビア', "name_en": 'Zambia' },
  { "code": 'ZWE', "name": 'ジンバブエ', "name_en": 'Zimbabwe' },
]

export default {
  data () {
    return {
      countries: _countries,
    }
  }
}

